import React from 'react';
import styled from '@emotion/styled';
import { alignItems, display, height, space, themeGet, width } from 'styled-system';

import { GridItem } from 'common/components/Grid';
import { ResponsiveLazyImage } from 'common/components/LazyImage';
import type { ResponsiveLazyImageProps } from 'common/components/LazyImage/types';
import { BodyRegularBR1 } from 'common/components/Typography';

interface UspItemProps {
  textHtml: string;
  image: ResponsiveLazyImageProps;
  isCompactWidth: boolean;
}

const ICON_RESPONSIVE_SIZES = ['60px', '66px', '68px', '74px'];
const ITEM_REGULAR_MODE_WIDTH = [1, 6 / 12];
const ITEM_COMPACT_MODE_WIDTH = [1, 8 / 12, 4 / 12];

const ImageContainer = styled.div<any>`
  ${width};
  ${height};
  ${space};
  ${display};
  ${alignItems};
`;

const imageContainerStyles = {
  my: 'sp_0',
  mx: 'auto',
  display: 'flex',
  alignItems: 'center',
  width: ICON_RESPONSIVE_SIZES,
  height: ICON_RESPONSIVE_SIZES,
};

const StyledResponsiveLazyImage = styled(ResponsiveLazyImage)<any>`
  ${width};
`;

const UspBlockText = styled(BodyRegularBR1)`
  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  a {
    text-decoration: underline;
    color: ${themeGet('colors.sys.neutral.text.default')};

    &:active,
    &:hover,
    &:focus {
      color: ${themeGet('colors.sys.primary.text.hover')};
    }
  }
`;

export const UspItem = ({ image, textHtml, isCompactWidth }: UspItemProps) => (
  <GridItem
    mb={['sp_24', null, null, 'sp_32']}
    width={isCompactWidth ? ITEM_COMPACT_MODE_WIDTH : ITEM_REGULAR_MODE_WIDTH}
  >
    <ImageContainer data-visual-test="blackout" {...imageContainerStyles}>
      <StyledResponsiveLazyImage width={1} {...image} />
    </ImageContainer>
    <UspBlockText mt="sp_16" dangerouslySetInnerHTML={{ __html: textHtml }} />
  </GridItem>
);
